const userContants = {
  USER_ACCESS_TOKEN: "token",
  USER_DETAILS: "user",
};
export {userContants}